// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Entity Type
 * @export
 * @enum {string}
 */
export var DatapointsEntityType;
(function (DatapointsEntityType) {
    DatapointsEntityType["Fund"] = "Fund";
    DatapointsEntityType["Portfolio"] = "Portfolio";
    DatapointsEntityType["Asset"] = "Asset";
    DatapointsEntityType["Manager"] = "Manager";
    DatapointsEntityType["Market"] = "Market";
    DatapointsEntityType["FundSeries"] = "FundSeries";
    DatapointsEntityType["Operation"] = "Operation";
})(DatapointsEntityType || (DatapointsEntityType = {}));
export function DatapointsEntityTypeFromJSON(json) {
    return json;
}
export function DatapointsEntityTypeToJSON(value) {
    return value;
}
